// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__185lP","left":"InfoRow_left__2aSB3"};